// extracted by mini-css-extract-plugin
export default {"container":"ValidationSection_container__1EWeC","imgWithMessage":"ValidationSection_imgWithMessage__zO4h1","alert":"ValidationSection_alert__N6FKx"};